/*
  Version: v01
  File: CertifiedBankCardPrivacyPolicyPage_v01.tsx
  Description: A2P compliant Privacy Policy page for CertifiedBankCard.com.
*/

import React from 'react';
import { Container } from 'react-bootstrap';

import CertifiedBankCardHeader_v01 from './CertifiedBankCardHeader_v01';
import CertifiedBankCardFooter_v01 from './CertifiedBankCardFooter_v01';

export default function CertifiedBankCardPrivacyPolicyPage_v01(): React.JSX.Element {
  return (
    <div className="bg-white text-dark">
      <CertifiedBankCardHeader_v01 />
      <section className="py-5">
        <Container style={{ maxWidth: '900px' }}>
          <h1 className="display-5 fw-bold mb-4">Privacy Policy</h1>
          <p className="text-muted">Effective date: April 23, 2026</p>

          <h2 className="h4 mt-4">1. Information We Collect</h2>
          <p>
            We may collect information you provide through forms on this website, including business name, contact name, phone number, email address,
            zip code, service interests, monthly volume, business type, and any message you submit.
          </p>

          <h2 className="h4 mt-4">2. How We Use Information</h2>
          <p>
            We use submitted information to respond to inquiries, evaluate interest in our services, provide follow-up communications, improve our website,
            and maintain business and compliance records.
          </p>

          <h2 className="h4 mt-4">3. SMS / A2P Privacy Notice</h2>
          <p>
            If you provide a phone number, we may use it to send service-related calls or text messages regarding your request, updates, and related business communications.
            SMS consent is not a condition of purchase. Message and data rates may apply. Message frequency may vary. Reply STOP to opt out and HELP for help.
          </p>
          <p>
            We may store phone numbers, consent-related details, and form submission records for compliance, documentation, and customer service purposes.
          </p>
          <p>
            Mobile opt-in data and consent information will not be shared with third parties for their own marketing purposes.
          </p>

          <h2 className="h4 mt-4">4. Sharing of Information</h2>
          <p>
            We may share information with service providers, technology vendors, compliance providers, funding partners, or payment-related partners only as needed
            to operate our business, evaluate requests, provide services, or comply with legal obligations.
          </p>

          <h2 className="h4 mt-4">5. Data Security</h2>
          <p>
            We take reasonable steps to protect personal and business information submitted through this website. However, no method of transmission or storage is completely secure.
          </p>

          <h2 className="h4 mt-4">6. Cookies and Analytics</h2>
          <p>
            This website may use cookies, analytics tools, and similar technologies to understand website usage and improve performance and user experience.
          </p>

          <h2 className="h4 mt-4">7. Your Choices</h2>
          <p>
            You may contact us to request updates to your information or to ask questions about how your information is used. You may opt out of SMS communications at any time by replying STOP.
          </p>

          <h2 className="h4 mt-4">8. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised effective date.
          </p>
        </Container>
      </section>
      <CertifiedBankCardFooter_v01 />
    </div>
  );
}

/*
  File Name: CertifiedBankCardPrivacyPolicyPage_v01.tsx
  Quick Description: A2P compliant Privacy Policy page component.
  Version: v01
*/
